import React from 'react';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  acceptContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(1)
  },
  label: {
    color: theme.palette.text.secondary
  },
  div: {
    display: 'flex',
    flexDirection: 'row'
  }
}));

type AutoAcceptComponentProps = {
  label: string;
  element: JSX.Element;
  trendsElement?: JSX.Element;
};

export const AutoAcceptComponent: React.FC<AutoAcceptComponentProps> = ({
  label,
  element,
  trendsElement
}: AutoAcceptComponentProps) => {
  const classes = useStyles();
  return (
    <>
      <div
        className={classes.acceptContainer}
        data-testid={`auto-accept-${label}`}
      >
        <Typography
          variant="body2"
          whiteSpace="nowrap"
          className={classes.label}
        >
          {label}
        </Typography>
        <div className={classes.div}>
          {element}
          {trendsElement}
        </div>
      </div>
    </>
  );
};
